module.exports = __webpack_public_path__ + "static/media/icon_delete_patient_select.3fc51d2f.svg";